import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons'

const NoFilteredEventsBox = () => {
  return <div style={{
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '24px',
    border: '2px dashed #d9d9d9',
    borderRadius: '8px',
  }}>
    <div style={{
      textAlign: 'center',
      color: '#8c8c8c',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '12px'
    }}>
      <FontAwesomeIcon
        icon={faExclamationTriangle}
        style={{ fontSize: '32px', color: '#faad14' }}
      />
      <div style={{ fontSize: '16px' }}>
        No events match the current filters
      </div>
    </div>
  </div>
}

export default NoFilteredEventsBox
